export default {
  createRem(pageW) {
    const bodyW = pageW || document.body.clientWidth
    const baseW = 375
    const ratio = bodyW / baseW
    const baseFont = 10
    const htmlDom = document.querySelector('html');
    htmlDom.style.fontSize = ratio * baseFont + 'px'
    document.body.style.fontSize = 16 + 'px'
  },
  isIOS() {
    return navigator.userAgent.match(/iPhone|iPod|iPad/i);
  },
  // 补全数字, 不够 2 位用 0 补全
  formatNumber(number) {
    return number < 10 ? '0' + number : number;
  },

  isIOS() {
    return navigator.userAgent.match(/iPhone|iPod|iPad/i);
  },

  formatTime(time) {
    time = new Date(parseInt(time, 10));
    return time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate() + " " + (time.getHours() < 10 ? "0" + time.getHours() : time.getHours()) + ":" + (time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()) + ":" + (time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds());
  },

  dateFormat(date, fmt) {
    date = new Date(String(date).replace(/\-/g, '/'));
    date = date === undefined ? new Date() : date;
    date = typeof date == 'number' ? new Date(date) : date;
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
    var obj = {
      y: date.getFullYear(), // 年份，注意必须用getFullYear
      M: date.getMonth() + 1, // 月份，注意是从0-11
      d: date.getDate(), // 日期
      q: Math.floor((date.getMonth() + 3) / 3), // 季度
      w: date.getDay(), // 星期，注意是0-6
      H: date.getHours(), // 24小时制
      h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
      m: date.getMinutes(), // 分钟
      s: date.getSeconds(), // 秒
      S: date.getMilliseconds(), // 毫秒
    };
    var week = ['天', '一', '二', '三', '四', '五', '六'];
    for (var i in obj) {
      fmt = fmt.replace(new RegExp(i + '+', 'g'), function (m) {
        var val = obj[i] + ''
        if (i == 'w') return (m.length > 2 ? '星期' : '周') + week[val]
        for (var j = 0, len = val.length; j < m.length - len; j++) val = '0' + val
        return m.length == 1 ? val : val.substring(val.length - m.length)
      })
    }
    return fmt
  },

  // 处理 Oct 26, 2017 11:55:47 AM
  // todo 增加 format 定制
  formatDate(str, onlyDate) {
    if (!str) {
      return '';
    }

    var date;
    // 兼容 safari
    if (str.match && str.match(/\d+\-\d+\-\d+ \d+:\d+:\d+/)) {
      date = this.newDate(str);
    } else {
      date = new Date(str);
    }

    var y = date.getFullYear();
    var m = this.formatNumber(date.getMonth() + 1);
    var d = this.formatNumber(date.getDate());
    var h = this.formatNumber(date.getHours());
    var min = this.formatNumber(date.getMinutes());
    var s = this.formatNumber(date.getSeconds());

    if (onlyDate) {
      return `${[y, m, d].join('-')}`;
    } else {
      return `${[y, m, d].join('-')} ${[h, min, s].join(':')}`;
    }
  },

  // todo 增加 format 定制
  // 开始小时 00 00 00
  formatStartDate(str, onlyDate) {
    if (!str) {
      return '';
    }

    var date;
    // 兼容 safari
    if (str.match && str.match(/\d+\-\d+\-\d+ \d+:\d+:\d+/)) {
      date = this.newDate(str);
    } else {
      date = new Date(str);
    }

    var y = date.getFullYear();
    var m = this.formatNumber(date.getMonth() + 1);
    var d = this.formatNumber(date.getDate());
    var h = this.formatNumber(date.getHours());
    var min = this.formatNumber(date.getMinutes());
    var s = this.formatNumber(date.getSeconds());

    if (onlyDate) {
      return `${[y, m, d].join('-')}`;
    } else {
      return `${[y, m, d].join('-')} ${['00', '00', '00'].join(':')}`;
    }
  },

  // 小时 00 00 00
  formatEndDate(str, onlyDate) {
    if (!str) {
      return '';
    }

    var date;
    // 兼容 safari
    if (str.match && str.match(/\d+\-\d+\-\d+ \d+:\d+:\d+/)) {
      date = this.newDate(str);
    } else {
      date = new Date(str);
    }

    date.setDate(date.getDate() + 1);

    var y = date.getFullYear();
    var m = this.formatNumber(date.getMonth() + 1);
    var d = this.formatNumber(date.getDate());
    var h = this.formatNumber(date.getHours());
    var min = this.formatNumber(date.getMinutes());
    var s = this.formatNumber(date.getSeconds());

    if (onlyDate) {
      return `${[y, m, d].join('-')}`;
    } else {
      return `${[y, m, d].join('-')} ${[h, min, s].join(':')}`;
    }
  },

  // dateString 的格式是 xxxx-xx-xx hh:mm:ss
  newDate(dateString) {
    if (dateString.replace) {
      // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
      return new Date(dateString.replace(' ', '\T').concat('.000+08:00'));
    } else {
      return new Date(dateString);
    }
  },
  excludeNull(obj) {
    for (let key in obj) {
      if (obj[key] === null || (typeof obj[key] === 'string' && obj[key].length == 0)) {
        delete obj[key];
      }
    }
  },

  // 生成min-max随机数
  randomNum(min, max) {
    var range = max - min;
    var rand = Math.random();
    var num = min + Math.floor(rand * range);
    return num;
  },

  // 分转成元
  //小数位为0直接显示整数，有一位显示一位，有多位显示两位
  filterPrice(data) {
    if (data) {
      var yuan = Number(data / 100);
      var fixed0 = yuan.toFixed(0);
      var fixed1 = yuan.toFixed(1);
      var fixed2 = yuan.toFixed(2);

      if (Number(fixed0) == Number(fixed1) && Number(fixed1) == Number(fixed2)) {
        return fixed0;
      } else if (Number(fixed0) != Number(fixed1) && Number(fixed1) == Number(fixed2)) {
        return fixed1;
      } else {
        return fixed2;
      }
    } else {
      return 0;
    }
  },
  // 元转成分
  filterPriceToFen(data) {
    if (data) {
      return Number(data * 100).toFixed(0);
    } else {
      return 0;
    }
  },

  // 截取部分字符，多出部分 ...
  subString(str, length) {
    if (!str) return '';

    if (str.length > length) {
      return str.substr(0, length) + '...';
    } else {
      return str;
    }
  },

  toTTContent(str) {
    return str.replace(new RegExp('<br>', 'gi'), '\n');
  },
  toHtmlContent(str) {
    return str.replace(new RegExp('\n', 'gi'), '<br>');
  },

  // 获取第几日的时间，今日GetDateStr(0)，昨日GetDateStr(-1)，前天GetDateStr(-2)
  GetDateStr(AddDayCount, onlyDate) {
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount);
    var y = dd.getFullYear();
    var m = this.formatNumber(dd.getMonth() + 1);
    var d = this.formatNumber(dd.getDate());
    var h = this.formatNumber(dd.getHours());
    var min = this.formatNumber(dd.getMinutes());
    var s = this.formatNumber(dd.getSeconds());
    if (onlyDate) {
      return `${[y, m, d].join('-')}`;
    } else {
      return `${[y, m, d].join('-')} ${[h, min, s].join(':')}`;
    }
  },

  // 获取第几月的时间，今日GetDateStr(0)，昨日GetDateStr(-1)，前天GetDateStr(-2)
  GetMonthStr(AddDayCount, onlyDate) {
    var dd = new Date();
    dd.setMonth(dd.getMonth() + AddDayCount);
    var y = dd.getFullYear();
    var m = this.formatNumber(dd.getMonth() + 1);
    var d = this.formatNumber(dd.getDate());
    var h = this.formatNumber(dd.getHours());
    var min = this.formatNumber(dd.getMinutes());
    var s = this.formatNumber(dd.getSeconds());
    if (onlyDate) {
      return `${[y, m, d].join('-')}`;
    } else {
      return `${[y, m, d].join('-')} ${[h, min, s].join(':')}`;
    }
  },
  secondToDate(second) { //秒转天时分秒
    var d, h, m, s
    d = Math.floor(second / 86400);
    h = Math.floor((second % 86400) / 3600);
    m = Math.floor((second % 3600) / 60);
    s = Math.floor((second % 60));
    return {
      d,
      h,
      m,
      s
    }
  },
  secondToHours(second) { //秒转小时
    return Math.floor(second / 3600 * 100) / 100
  },

  /*
   *获取链接参数
   */
  getUrlParam(url, name) {
    try {
      if (!url) return null;
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 构造一个含有目标参数的正则表达式对象
      let splitStr = url.split('?')[1];
      let subStr = splitStr.substr(0);
      let temp = subStr.match(reg); // 匹配目标参数
      if (temp != null) return unescape(temp[2]);
      return null; // 返回参数值
    } catch (error) {
      return ''; // 返回参数值
    }
  },
  saveTwo(num) {
    if (Number(num) < 10) {
      return '0' + num
    }
    return num + ''
  },
  countdown(countdown = 0, isTranslateDay = false) {
    let day = 0
    let hour = 0
    let min = 0
    let sec = 0
    countdown = countdown / 1000
    if (isTranslateDay) {
      day = this.saveTwo(parseInt(countdown / (24 * 60 * 60)))
      hour = this.saveTwo(parseInt((countdown / (60 * 60)) % 24))
      min = this.saveTwo(parseInt((countdown / 60) % 60))
      sec = this.saveTwo(parseInt(countdown % 60))

      return {
        day,
        hour,
        min,
        sec,
      }
    }

    hour = this.saveTwo(parseInt((countdown / (60 * 60))))
    min = this.saveTwo(parseInt((countdown / 60) % 60))
    sec = this.saveTwo(parseInt(countdown % 60))

    return {
      hour,
      min,
      sec,
    }
  },
};
